import ClassenService from '../ClassenService';

class ExportService {
  uploadExcel(uploadData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/import`, 'uploadExcel', uploadData);
  }

  getImageZip(requestData) {
    return ClassenService.doApiCall('post', `${process.env.VUE_APP_API}/exports/zip`, 'getImageZip', requestData);
  }
}

export default new ExportService();
